module.exports = __webpack_public_path__ + "img/customer-service-icon.e77f54a0.png";